import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { useState } from 'react'
import { TRPCProvider } from './trpc'
import { trpcClient } from './trpc-client'

export function Providers({ children }: { children: React.ReactNode }) {
  const [queryClient] = useState(() => new QueryClient())

  return (
    <QueryClientProvider client={queryClient}>
      <TRPCProvider trpcClient={trpcClient} queryClient={queryClient}>
        {children}
      </TRPCProvider>
    </QueryClientProvider>
  )
}
